module.exports = __webpack_public_path__ + "static/media/socialNetworking.78f89164.jpg";